import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/social-youtube.svg';

export const IconSocialYoutube: IconComponent = props => <Icon {...props} src={src} />;
